import axios from "axios";

export const resetState = (payload) => {
  return axios.put("users/v1/superuser/reset-prakerja-state", payload);
};

export default { resetState };
